import type { CommissionStatus } from './types';

export const COMMISSION_STATUSES: readonly { value: CommissionStatus; label: string }[] = [
  { value: 'pending', label: 'Pending' },
  { value: 'earned', label: 'Earned' },
  { value: 'paid_out', label: 'Paid out' },
  { value: 'void', label: 'Void' },
];

const STATUS_LABEL: Record<CommissionStatus, string> = {
  pending: 'Pending',
  earned: 'Earned',
  paid_out: 'Paid out',
  void: 'Void',
};

export const commissionStatusLabel = (s: CommissionStatus): string => STATUS_LABEL[s] ?? s;

export function commissionStatusVariant(
  s: CommissionStatus,
): 'default' | 'secondary' | 'outline' {
  if (s === 'earned') return 'default';
  if (s === 'paid_out') return 'secondary';
  return 'outline';
}
